module.exports = __webpack_public_path__ + "img/logo_simbolo_semfundo.8879f897.png";